export default __webpack_public_path__ + "static/media/wavier.0cf5b49d.jpg";